<template>
  <div
    class="rounded-full animate-spin"
    :class="[size, border, color]"
  ></div>
</template>

<script>

export default {
  name: "RpmSpinner",
  props: {
    size: {
      type: String,
      default: 'h-6 w-6',
    },
    border: {
      type: String,
      default: 'border-4',
    },
    color: {
      type: String,
      default: 'border-gray-300 border-t-theme',
    }
  },
};

</script>
